import React from 'react';
import './Header.css';
import logo from '../assets/logo50pc.png';

const Header = () => (
  <header className="header">
    <div className="header-container">
      <img src={logo} alt="Frios & Cia" className="header-logo" />
    </div>
  </header>
);

export default Header;
